import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";

import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Stack from "@mui/material/Stack";
import UiSwitch, {
     UiSwitchList,
} from "../../../_uiComponents/common/form/UiSwitch";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from "../../../_uiComponents/common/table/UiTableHead";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import {
     UiGridType,
     ApprovedIcon,
     NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Popover from '@mui/material/Popover';
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";
import LookUpTableFilterForm from "../forms/LookupTableFilterForm";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import {
     lookupTableListRequest,
     lookupTableDeleteRequest,
     lookupTableActiveInactiveRequest,
     lookupTableValueListRequest,
     lookupTableSaveSearchValues,
} from "../../../../_redux/_actions";
import { lookupTableConfig } from "../module.config";

import LookupTableRowManagement from "./LookupTableRowManagement";
import LookupTableRowDetails from "./LookupTableRowDetails";


function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function LookupTableManagement(props) {
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const tableRowId = useRef();
     const [anchorEl, setAnchorEl] = React.useState(null);
     const [lookUpPage, setLookupPage] = useState();
     const [lookupPageSize, setLookupPageSize] = useState();
     const [inUseValue, setInUserValue] = useState([]);

     const popOverOpen = (event) => {
          setAnchorEl(event.currentTarget);
     };

     const popOverClose = () => {
          setAnchorEl(null);
     };

     const show = Boolean(anchorEl);
     const id = show ? 'simple-popover' : undefined;


     const actionDispatch = useDispatch();
     const navigate = useNavigate();
     const [state, dispatch] = useContext(Context);


     useEffect(() => {
          getLookupTableList();
     }, [page, rowsPerPage]);

     const getLookupTableList = (data) => {
          actionDispatch(
               lookupTableListRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    ...data,
               }),
          );
     };




     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

     const { tableList, totalRecords } = useSelector((state) => {
          return {
               tableList: state.lookupTable.list.data,
               totalRecords: state.lookupTable.list.totalRecords,
          };
     });


     const deleteLookupTable = (id) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () =>
                         actionDispatch(
                              lookupTableDeleteRequest({
                                   id,
                                   page: page,
                                   pageSize: rowsPerPage,
                              }),
                         ),
               },
          });
     };

     const showTableRowInfo = (id) => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Lookup table details",
                    children: <LookupTableRowDetails id={id} />,
               },
          });
     };

     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [open, setOpen] = React.useState(false);
     const [active, setActive] = React.useState();
     const [editModal, setEditModal] = React.useState(false);
     const [character, setCharacter] = React.useState("");

     const handleEditShow = () => setEditModal(true);
     const handleCloseEdit = () => setEditModal(false);

     const manageOpen = (clickedIndex, tableId) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpen(true);
          } else {
               setActive(clickedIndex);
               setOpen(true);
               tableRowId.current = tableId;
               getTableRowValueList();
          }
     };

     const getTableRowValueList = (searchValue = "") => {
          actionDispatch(
               lookupTableValueListRequest({
                    page: searchValue !== "" ? (lookUpPage || 1) : 1,
                    pageSize: searchValue !== "" ? (lookupPageSize || 100) : 5,
                    lookupTableId: tableRowId.current,
                    search: searchValue,
               }),
          );

          actionDispatch(lookupTableSaveSearchValues({search: searchValue}))

     };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
        
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          const isAsc = orderBy === property && order === "asc";
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };

     //Add row modal
     const [openAddFieldModal, setOpenAddFieldModal] = React.useState(false);
     const subTableModalOpen = () => setOpenAddFieldModal(true);
     const handleClose = () => setOpenAddFieldModal(false);


     //Data sorting
     const sortingRows = React.useMemo(
          () =>
               stableSort(tableList, getComparator(order, orderBy)),
          [order, orderBy, page, rowsPerPage, tableList],
     );
     //Drag and drop reorder
     const reorder = (list, startIndex, endIndex) => {
          const result = Array.from(list);
          const [removed] = result.splice(startIndex, 1);
          result.splice(endIndex, 0, removed);
          return result;
     };

     //Switch function
     const handleChangeActiveInactive = (value, id) => {
          actionDispatch(
               lookupTableActiveInactiveRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    value,
                    id,
               }),
          );
          // let newArr = [...newRows];
          // newArr[index].enable = event.target.checked;
          // setNewRows(newArr);
     };

        const inUserValue = (id) => {
          setInUserValue(sortingRows.filter(row => row.id === id)[0]);
     }



     return (
          <>
               <UiAccordian>
                    <SearchBarWr>
                         <LookUpTableFilterForm
                              getLookupTableList={getLookupTableList}
                         />
                    </SearchBarWr>
               </UiAccordian>
               <div className="sba-table-main-wr">
                    <UiTableWrapper>
                         <UiTableHead
                              headings={lookupTableConfig.list.tableMapper}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />

                         <UiTableBody>
                              {sortingRows.map((row, index) => (
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             {lookupTableConfig.list.tableMapper.map(
                                                  (headCell, index) => {
                                                       if (headCell.isShow) {
                                                            return headCell.type ==
                                                                 "text" ? (
                                                                 <TableCell
                                                                      align={
                                                                           headCell.align
                                                                      }
                                                                 >
                                                                      {headCell.isNormalTest ? (
                                                                           <span className="sba-type-bg">
                                                                                {


                                                                                     row[

                                                                                     headCell
                                                                                          .id

                                                                                     ]
                                                                                }
                                                                           </span>
                                                                      ) : (
                                                                           <strong>

                                                                                {
                                                                                     row[
                                                                                     headCell
                                                                                          .id
                                                                                     ]
                                                                                }
                                                                           </strong>
                                                                      )}
                                                                 </TableCell>
                                                            ) : (
                                                                 <>
                                                                      {headCell.id ==
                                                                           "inUse" && (
                                                                                <TableCell align="center">
                                                                                     {row.inUse ? (
                                                                                          <>
                                                                                               <IconButton onClick={(e) => {popOverOpen(e); inUserValue(row.id)}}>
                                                                                                    <ApprovedIcon />
                                                                                               </IconButton>
                                                                                               <Popover
                                                                                                    id={id}
                                                                                                    open={show}
                                                                                                    anchorEl={anchorEl}
                                                                                                    onClose={popOverClose}
                                                                                                    anchorOrigin={{
                                                                                                         vertical: 'bottom',
                                                                                                         horizontal: 'left',
                                                                                                    }}
                                                                                               >
                                                                                                    <ul className="sb-popover-wr">
                                                                                                    {inUseValue?.inUseTables?.map((name, index) => (
                                                                                                         <li key={index}>{name}</li>
                                                                                                    ))}
                                                                                                    </ul>
                                                                                               </Popover>
                                                                                          </>

                                                                                     ) : (
                                                                                          <NotApprovedIcon />
                                                                                     )}{" "}
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "active" && (
                                                                                <TableCell align="center">
                                                                                     <UiSwitchList
                                                                                          checked={
                                                                                               row.active
                                                                                          }
                                                                                          handleChange={(
                                                                                               event,
                                                                                          ) => {
                                                                                               handleChangeActiveInactive(
                                                                                                    event,
                                                                                                    row.id,
                                                                                               );
                                                                                          }}
                                                                                          name={
                                                                                               row.name
                                                                                          }
                                                                                     />
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "labels" && (
                                                                                <TableCell align="left">
                                                                                     <div className="sba-label-type-wr">
                                                                                          {row.labels.map(
                                                                                               (
                                                                                                    label,
                                                                                               ) => (
                                                                                                    <UiGridType
                                                                                                         name={
                                                                                                              label
                                                                                                         }
                                                                                                    />
                                                                                               ),
                                                                                          )}
                                                                                     </div>
                                                                                </TableCell>
                                                                           )}
                                                                      {headCell.id ==
                                                                           " " && (
                                                                                <TableCell align="left"></TableCell>
                                                                           )}
                                                                 </>
                                                            );
                                                       } else {
                                                       }
                                                  },
                                             )}

                                             <TableCell align="center">
                                                  <Button
                                                       size="small"
                                                       variant="outlined"
                                                       endIcon={
                                                            active == index &&
                                                                 open ? (
                                                                 <KeyboardArrowUpIcon />
                                                            ) : (
                                                                 <KeyboardArrowDownIcon />
                                                            )
                                                       }
                                                       onClick={() => {
                                                            manageOpen(
                                                                 index,
                                                                 row.id,
                                                            );
                                                       }}
                                                  >
                                                       Data
                                                  </Button>
                                             </TableCell>
                                             <TableCell
                                                  align="right"
                                                  sx={{ width: "110px" }}
                                             >
                                                  <div className="sbt-data-grid__action-bar">
                                                       <InfoIcon
                                                            onClick={() =>
                                                                 showTableRowInfo(
                                                                      row.id,
                                                                 )
                                                            }
                                                            className="sba-grid-info-icon"
                                                       />
                                                       <Tooltip
                                                            title="Edit"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="Edit"
                                                                 onClick={() =>
                                                                      navigate(
                                                                           "/app/lookup-data-manage/edit/" +
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 sx={{
                                                                      ml: 1.5,
                                                                 }}
                                                            >
                                                                 <EditIcon />
                                                            </IconButton>
                                                       </Tooltip>
                                                       <Tooltip
                                                            title="Delete"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 onClick={() =>
                                                                      deleteLookupTable(
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 aria-label="delete"
                                                                 sx={{
                                                                      ml: 0.5,
                                                                 }}
                                                            >
                                                                 <DeleteIcon color="error" />
                                                            </IconButton>
                                                       </Tooltip>
                                                  </div>
                                             </TableCell>
                                        </TableRow>

                                        <TableRow>
                                             <TableCell
                                                  style={{
                                                       paddingBottom: 0,
                                                       paddingTop: 0,
                                                       border: "none",
                                                       background: "#f9f8f8",
                                                       borderBottom: "none",
                                                  }}
                                                  colSpan={12}
                                             >
                                                  <Collapse
                                                       in={
                                                            active == index &&
                                                            open
                                                       }
                                                       timeout="auto"
                                                       unmountOnExit
                                                  >
                                                       {active == index &&
                                                            open && (
                                                                 <LookupTableRowManagement
                                                                      tableId={
                                                                           row.id
                                                                      }
                                                                      tableType={
                                                                           row.type
                                                                      }
                                                                      getTableRowValueList={
                                                                           getTableRowValueList
                                                                      }
                                                                      lookUpPage={setLookupPage}
                                                                      lookUpPageSize={setLookupPageSize}

                                                                 />
                                                            )}
                                                  </Collapse>
                                             </TableCell>
                                        </TableRow>
                                   </>
                              ))}
                              {/* {emptyRows > 0 && (
                                   <TableRow
                                        style={{
                                             height: 53 * emptyRows,
                                        }}
                                   >
                                        <TableCell colSpan={6} />
                                   </TableRow>
                              )} */}
                         </UiTableBody>
                    </UiTableWrapper>
               </div>
               <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
          </>
     );
}
